define('GameDayCore/GDModel/ValueObjects/Linescore/LinescoreMedia',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(LinescoreMedia);

	function LinescoreMedia($data) {
		var vo = VO.ensureVO(this, LinescoreMedia),
			data = $data;

		vo.type = data.type || "";
		vo.calendar_event_id = data.calendar_event_id || "";
		vo.start = data.start || "";
		vo.title = data.title || "";
		vo.has_mlbtv = data.has_mlbtv || "";
		vo.free = data.free || "";
		vo.media_state = data.media_state || "";
		vo.thumbnail = data.thumbnail || "";
	}

	return LinescoreMedia;
});
